var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34174 26.9096L9.7917 25.3339C9.90944 25.2059 10.041 25.0914 10.184 24.9925L20.1007 18.1325C20.7408 17.6897 21.5585 17.5926 22.2845 17.8731L37.9191 23.9137C39.6267 24.5735 39.9576 26.8458 38.5091 27.9651L26.7693 37.0371C26.0896 37.5623 25.1775 37.6748 24.3905 37.3305L9.12905 30.6536C7.65078 30.0069 7.24915 28.0969 8.34174 26.9096Z",
    fill: "#E5E5E5",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11956 7.63916L6.55455 7.95556C6.41484 8.0338 6.31511 8.16789 6.28037 8.32421C6.24724 8.47332 6.27619 8.62949 6.36057 8.75682L14.515 21.0617C14.8564 21.5769 15.5336 21.7483 16.079 21.4574C16.4698 21.2489 16.7139 20.8421 16.7139 20.3992V12.0118C16.7139 11.4989 16.4071 11.0356 15.9347 10.8356L8.24188 7.57745C7.87834 7.42347 7.46403 7.44626 7.11956 7.63916Z",
    fill: "url(#paint0_linear_6626_21935)",
    stroke: "#20364B",
    strokeWidth: 0.362785,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03948 19.7882L6.47447 20.1046C6.33476 20.1828 6.23503 20.3169 6.20029 20.4733C6.16716 20.6224 6.19611 20.7785 6.28049 20.9059L14.4349 33.2107C14.7764 33.726 15.4535 33.8973 15.9989 33.6064C16.3897 33.398 16.6338 32.9911 16.6338 32.5482V24.1609C16.6338 23.6479 16.327 23.1847 15.8546 22.9846L8.16181 19.7265C7.79826 19.5725 7.38395 19.5953 7.03948 19.7882Z",
    fill: "url(#paint1_linear_6626_21935)",
    stroke: "#20364B",
    strokeWidth: 0.362785,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3871 11.8724L16.8221 12.1888C16.6824 12.2671 16.5827 12.4012 16.5479 12.5575C16.5148 12.7066 16.5438 12.8628 16.6281 12.9901L24.7826 25.295C25.124 25.8102 25.8012 25.9815 26.3466 25.6906C26.7374 25.4822 26.9815 25.0754 26.9815 24.6325V16.2451C26.9815 15.7321 26.6746 15.2689 26.2023 15.0689L18.5095 11.8107C18.1459 11.6568 17.7316 11.6795 17.3871 11.8724Z",
    fill: "url(#paint2_linear_6626_21935)",
    stroke: "#20364B",
    strokeWidth: 0.362785,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3051 24.0182L16.7401 24.3346C16.6004 24.4128 16.5007 24.5469 16.4659 24.7032C16.4328 24.8523 16.4617 25.0085 16.5461 25.1358L24.7005 37.4407C25.042 37.956 25.7191 38.1273 26.2646 37.8364C26.6554 37.628 26.8995 37.2211 26.8995 36.7782V28.3909C26.8995 27.8779 26.5926 27.4147 26.1202 27.2146L18.4274 23.9565C18.0639 23.8025 17.6496 23.8253 17.3051 24.0182Z",
    fill: "url(#paint3_linear_6626_21935)",
    stroke: "#20364B",
    strokeWidth: 0.362785,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.16571,
    y: 0.255172,
    width: 10.1649,
    height: 10.1649,
    rx: 0.830979,
    transform: "matrix(0.913545 0.406737 0 1 5.92839 7.56993)",
    fill: "#BDE5FF",
    stroke: "#20364B",
    strokeWidth: 0.362785
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.16571,
    y: 0.255172,
    width: 10.1649,
    height: 10.1649,
    rx: 0.830979,
    transform: "matrix(0.913545 0.406737 0 1 5.84245 19.719)",
    fill: "#BDE5FF",
    stroke: "#20364B",
    strokeWidth: 0.362785
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.16571,
    y: 0.255172,
    width: 10.1649,
    height: 10.1649,
    rx: 0.830979,
    transform: "matrix(0.913545 0.406737 0 1 16.194 11.8048)",
    fill: "#BDE5FF",
    stroke: "#20364B",
    strokeWidth: 0.362785
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.16571,
    y: 0.255172,
    width: 10.1649,
    height: 10.1649,
    rx: 0.830979,
    transform: "matrix(0.913545 0.406737 0 1 16.1081 23.9521)",
    fill: "#BDE5FF",
    stroke: "#20364B",
    strokeWidth: 0.362785
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6626_21935",
    x1: 11.4712,
    y1: 7.33337,
    x2: 11.4712,
    y2: 21.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1266AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6626_21935",
    x1: 11.3911,
    y1: 19.4824,
    x2: 11.3911,
    y2: 34.1194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1266AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6626_21935",
    x1: 21.7388,
    y1: 11.5667,
    x2: 21.7388,
    y2: 26.2036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1266AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6626_21935",
    x1: 21.6568,
    y1: 23.7124,
    x2: 21.6568,
    y2: 38.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1266AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D1F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.9191ef93e3ef7a1421e9e1f34856d951.svg";
export { ForwardRef as ReactComponent };